module.exports = __webpack_public_path__ + "static/SplenaRetouch2-7337a7f32e227375e88bd8d2074838d7.jpg";